import type { AnalyticsRange } from './types';

const STORAGE_KEY = 'aidu.vendor.analytics.range';
const VALID: AnalyticsRange[] = ['WEEK', 'MONTH', 'YEAR'];

export function loadStoredRange(): AnalyticsRange {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && VALID.includes(stored as AnalyticsRange)) {
      return stored as AnalyticsRange;
    }
  } catch {
    // localStorage unavailable
  }
  return 'WEEK';
}

export function persistRange(range: AnalyticsRange): void {
  try {
    localStorage.setItem(STORAGE_KEY, range);
  } catch {
    // ignore
  }
}
